import React from 'react';
import { IconButton } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

function BaseIconButton({ children, ...props }) {
  let buttonProps = { ...props };
  if (props.to) {
    buttonProps.component = RouterLink;
  }
  return <IconButton {...buttonProps}>{children}</IconButton>;
}

export default BaseIconButton;
